<template>
  <div v-if="isShown" class="flex-center pb-3 mt-3 bg-white flex-col relative">
    <niceone-image v-for="(img, index) in product.catalog_images" :key="`catalog-item-${index}`" :src="img"/>
  </div>
</template>

<script setup>
const props = defineProps({
  product: {
    type: Object,
    default: () => {
    }
  }
})
const isShown = computed(() => props.product?.catalog_images && props.product?.catalog_images?.length)
</script>

<style lang="scss" scoped>
</style>